// @flow
/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['last'] }] */

import * as React from 'react';

import { Icon } from '@ta/styleguide.icon';

import styles from './SocialAction.less';

export type Props = {
  icon: string,
  count?: number,
  isActive: boolean,
};

export type State = {
  count?: number,
  isActive: boolean,
};

/**
 * Display a social action icon - Helpful Votes, Saves/Bookmark, Comments, Share
 */
export default class SocialAction extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { count: this.props.count, isActive: this.props.isActive };
  }

  memberGeneratedAction = () => {
    if (!this.state.isActive) {
      this.setState({ count: this.state.count + 1, isActive: true });
    } else if (this.state.count != null && this.state.count > 0) {
      this.setState({ count: this.state.count - 1, isActive: false });
    }
  };

  render() {
    return (
      <span
        className={`${styles.social_action} ${this.state.isActive ? styles.active : ''}`}
        onClick={this.memberGeneratedAction}
      >
        <Icon name={this.props.icon} className={styles.icon} />
        <span className={styles.text}>{this.state.count}</span>
      </span>
    );
  }
}
